<template lang="html">
  <div
    :id="elementId"
    @mousemove="setSprite($event)"
    @mouseout="clearSprite()"
    >
    <div class="thumbnail-default" v-show="spriteOffset === null"
      :style="defaultStyling">
    </div>
    <div class="thumbnail-previews" :class="{'invisible': spriteOffset === null}"
      :style="[baseThumbsStyling, activeThumbsStyling]"
    ></div>
  </div>
</template>

<script>
// Thumbnail component
// Render the thumbnail for a video in the marker vod list
// Display iPhoto-style previews of the video when hovering

export default {
  data () {
    return {
      elementId: `thumbnail-${this._uid}`,
      spriteOffset: null,
      sprite: undefined,
    }
  },
  props: [
    'media',
    'default'
  ],
  created () {
    const sprite = this.media.find(el => el.name === 'thumbspritehoriz')
    if (typeof this.sprite !== undefined) {
      // after record cutting we have new width and height of sprite in database
      // but Cloudfront gives old sprite for some time (cache)
      // so we have to get natural size of sprite to get correct frames calculation
      const img = new Image()
      img.onload = event => this.setSpriteSize(event, sprite)
      img.src = sprite.url
    }
  },
  methods: {
    setSpriteSize (event, sprite) {
      sprite.width = event.target.naturalWidth
      sprite.height = event.target.naturalHeight
      this.sprite = this.adjustSpriteSize(sprite, 150)
    },
    // update the thumbnail on mouse hover
    setSprite (event) {
      if (typeof this.sprite === 'undefined') {
        // abort if no sprite is available for this record (legacy support)
        return
      }
      // calculate the offset of the sprite based on the mouse position
      let rect = document.getElementById(this.elementId).getBoundingClientRect()
      let xoffset = event.clientX - rect.left
      let percent = xoffset / rect.width
      let spriteOffset = Math.floor(this.sprite.width * percent / this.sprite.sprite_interval_h) * this.sprite.sprite_interval_h
      this.spriteOffset = -spriteOffset
    },
    clearSprite () {
      this.spriteOffset = null
    },
    adjustSpriteSize (sprite, minHeight) {
      // make the sprite fit into the desired height
      if (sprite.height < minHeight) {
        let ratio = minHeight / sprite.height
        sprite.sprite_interval_h = Math.floor(sprite.sprite_interval_h * ratio)
        sprite.width = Math.floor(sprite.width * ratio)
        sprite.height = minHeight
      }
      return sprite
    }
  },
  computed: {
    defaultStyling () {
      return {
        backgroundImage: `url(${this.default})`
      }
    },
    baseThumbsStyling () {
      // return the styles to be applied to the thumbnail div
      if (typeof this.sprite === 'undefined') {
        return {}
      } else {
        return {
          backgroundImage: `url(${this.sprite.url})`,
          backgroundSize: `${this.sprite.width}px ${this.sprite.height}px`
        }
      }
    },
    activeThumbsStyling () {
      if (this.spriteOffset === null) {
        return {}
      } else {
        return {
          backgroundPosition: `${this.spriteOffset}px`
        }
      }
    }
  }
}
</script>

<style>
  .invisible {
    opacity: 0.001; /* workaround for safari not preloading hidden images */
  }
</style>



// WEBPACK FOOTER //
// Thumbnail.vue?60efdac4